import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const lightTheme = {
  root: {
    '& .MuiSvgIcon-root': {},
    '& $heading': {
      color: TextColors.dark,
    },
    '& $content': {
      '& h1, h2, h3, h4, h5, h6': {
        color: TextColors.dark,
      },
      '& p': {
        color: hexToRGBA(TextColors.dark, TextOpacities.light1),
      },
      '& a:hover': {
        color: SecondaryColors.dark,
      },
    },
    '& $resource': {
      color: TextColors.dark,
    },
    '& $divider': {
      background: hexToRGBA(TextColors.dark, TextOpacities.light4),
    },
    '& $accordion': {
      '& .MuiIconButton-root': {
        color: SecondaryColors.dark,
      },
    },
  },
};

const darkTheme = {
  root: {
    '& .MuiSvgIcon-root': {},
    '& $heading': {
      color: TextColors.light,
    },
    '& $content': {
      '& h1, h2, h3, h4, h5, h6': {
        color: `${TextColors.light}`,
      },
      '& p': {
        color: hexToRGBA(TextColors.light, TextOpacities.dark1),
      },
      '& a:hover': {
        color: SecondaryColors.main,
      },
    },
    '& $resource': {
      color: TextColors.light,
    },
    '& $divider': {
      background: hexToRGBA(TextColors.light, TextOpacities.dark4),
    },
    '& $accordion': {
      '& .MuiIconButton-root': {
        color: SecondaryColors.main,
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,

      '& .MuiPaper-root': {
        backgroundColor: 'transparent',
      },
      [muiTheme.breakpoints.down('sm')]: {
        marginTop: '20px',
      },
    },
    heading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(3),
      },
    },
    content: {
      '& a:not(:hover)': {
        textDecoration: 'none',
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
    rtc: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(3),
      },
    },
    accordion: {
      '&, &.MuiAccordion-root.Mui-expanded': {
        margin: 0,
      },

      '&.MuiAccordion-root:before': {
        display: 'none',
      },

      '& .MuiAccordionSummary-root': {
        padding: 0,
        border: 'none',
        justifyContent: 'flex-start',

        '&, &.Mui-expanded': {
          minHeight: '0',
        },
      },

      '& .MuiAccordionDetails-root': {
        padding: 0,
        marginBottom: muiTheme.spacing(2),
      },

      '& .MuiAccordionSummary-content': {
        flexGrow: '0',

        '&, &.Mui-expanded': {
          margin: muiTheme.spacing(1, 0),
        },
      },

      '& .MuiButtonBase-root.MuiIconButton-root': {
        border: 'none !important',
        padding: muiTheme.spacing(0.5),
      },
    },
    socialPlatforms: {
      margin: muiTheme.spacing(-1, -1, 3),

      '& a': {
        width: '20px',
        height: '20px',
        display: 'block',
      },
    },
    resource: {
      '&:not(:first-child) $heading': {
        marginTop: muiTheme.spacing(6),
      },
    },
    divider: {
      margin: muiTheme.spacing(2.75, 0, 3),
      width: '100%',
      height: '1px',
    },
  }),
  { name: 'GenPressCenterResourceSideContent' },
);

export default useStyles;
